import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import ReCaptcha from '../ReCaptcha';
import devices from '../../styles/devices';
import getErrorMsg from '~/helpers/errorMessages';
import { Button as ButtonElement, MaskField } from '~/elements';

const ContainerActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 15px;
`;
const ContainerReCaptcha = styled.div`
  height: 76px;
  margin-top: 20px;
`;
const CardNumber = styled(MaskField)`
  max-width: 335px;
  label,
  input {
    font-size: 0.9375rem !important;
  }

  @media (min-width: ${devices?.desktop}) {
    label,
    input {
      color: ${({ theme }) => theme.colors.gray400} !important;
    }
    .MuiInput-underline:before {
      border-color: ${({ theme }) => theme.colors.gray400} !important;
    }
  }
`;
const Button = styled(ButtonElement)`
  margin-top: 15px !important;
`;
const Form = styled.form`
  padding: 0 15px;

  button {
    width: 100%;
  }

  @media (min-width: ${devices?.desktop}) {
    padding: 0;
  }
`;

export default function QuickSearchForm({
  reCaptchaKey,
  onSubmit,
  clearValues,
}) {
  const [recaptchaIsValid, setRecaptchaIsValid] = useState(false);
  const { handleSubmit, errors, formState, ...formControl } = useForm({
    mode: 'onChange',
  });

  useEffect(() => {
    if (clearValues) {
      formControl.setValue('cardNumber', '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearValues]);
  function validateCard(cardNumber) {
    /**
      Lista dos códigos BIN
      https://jira.vrbeneficios.io/secure/attachment/52577/BINS-VR-VALIDACAO.png
    */

    const validBins = [
      '627416',
      '636350',
      '637036',
      '637037',
      '637200',
      '637201',
      '637202',
      '637430',
      '637441',
    ];
    const currentNumber = cardNumber.split(' ').join('');
    if (currentNumber.length >= 6) {
      const sixDigits = currentNumber.substring(0, 6);
      if (validBins.includes(sixDigits)) {
        return true;
      }
    }
    return false;
  }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <ContainerActions>
        <CardNumber
          ariaLabel="número do cartão"
          label="Número completo do cartão"
          fullWidth
          name="cardNumber"
          mask="9999  9999  9999  9999"
          type="tel"
          rules={{
            required: true,
            minLength: 22, // 22 e não 16 pois precisa contar os espaços da mask
            validate: val => validateCard(val),
          }}
          formControl={formControl}
          error={!!errors.cardNumber}
          caption={getErrorMsg(errors, 'cardNumber')}
        />
        <ContainerReCaptcha>
          {reCaptchaKey && (
            <ReCaptcha
              onChange={() => setRecaptchaIsValid(true)}
              sitekey={reCaptchaKey}
            />
          )}
        </ContainerReCaptcha>
      </ContainerActions>
      <Button
        ariaLabel="botão fazer consulta do cartão"
        disabled={!formState.isValid || !recaptchaIsValid}
        color="primary"
        label="Fazer consulta"
        type="submit"
      />
    </Form>
  );
}

QuickSearchForm.propTypes = {
  reCaptchaKey: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  clearValues: PropTypes.bool,
};
